import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  Divider,
  Grid,
  Link,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import React, { FC, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import toast from 'react-hot-toast';
import { useNavigate, Link as RouterLink, useParams, } from 'react-router-dom';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { getEWasteStatusColor, getStatusColor } from 'src/components/masters/customFunctions';
import { EwasteProduct, EWasteRequestDetails } from 'src/interfaces/repair-request/e-waste-request';
import { eWasteRequestApi } from 'src/api/eWasteApi';
import { format } from 'date-fns';
import { EWASTE_SERVICE_ID, PLASTIC_WASTE_SERVICE_ID, UCO_WASTE_SERVICE_ID } from 'src/constants/common-constant';
import { userApi } from '../../api/user';
import { ResponseCodes } from '../../enums/responseCodes';
import { CustomerGetResponse, CustomerUser } from '../../interfaces/user/customer';
import loadingContext from '../../loderContext';
import { Address, CustomerAddress, ICoupon } from '../../interfaces/new-channel-partner/channelPartner';
import { GetUserProductResponse } from '../../interfaces/userProduct/user-product';
import { RequestDetails, Slot } from '../../interfaces/repair-request/repair-request';
import { requestApi } from '../../api/request';
import { SelectedIssue } from '../../interfaces/masters/issue/issue';
import { REPAIR_SERVICE_ID } from '../../constants/repairRequest-constants';
import { userProductApi } from '../../api/userProduct';
import { PaginationAndFilter } from '../../interfaces/common/pagination';
import { MobileNumberCard } from '../../components/customers/customerView/cards/mobileNumberCard';
import { CreateProfileCard } from '../../components/customers/customerView/cards/createProfileCard';
import { ProfileDetailsCard } from '../../components/customers/customerView/cards/profileDetailsCard';
import { RaiseRequestDetailsCard } from '../../components/customers/customerView/cards/RaiseRequestDetailsCard';
import { RequestSuccessDialog } from '../../components/customers/customerView/dialogs/requestConfirmedDialog';
import RequestList from './requestList';

interface CustomerViewProps {
  enableRaiseRequest: boolean
}

export const CustomerView: FC<CustomerViewProps> = (props) => {
  const { setLoading } = useContext(loadingContext);
  const { customerId } = useParams();
  const navigate = useNavigate();
  const [productDetails, setProductDetails] = useState<GetUserProductResponse>();
  const [issues, setIssues] = useState<string[]>([]);
  const [mobile, setMobile] = useState<string>('');
  const [selectedAddress, setSelectedAddress] = useState<CustomerAddress>();
  const [allUserProducts, setAllUserProducts] = useState<GetUserProductResponse[]>([]);
  const [userDetails, setUserDetails] = useState<CustomerGetResponse>();
  const [userFound, setUserFound] = useState<boolean>(true);
  const [openSuccessDialog, setOpenSuccessDialog] = useState<boolean>(false);
  const [channelPartnerId, setChannelPartnerId] = useState<string>('');
  const [requestDetails, setRequestDetails] = useState<RequestDetails>();
  const [repairRequestList, setRepairRequestList] = useState<RequestDetails[]>([]);
  const [eWasteRequestList, setEWasteRequestList] = useState<EWasteRequestDetails[]>([]);
  const [plasticRequestList, setPlasticRequestList] = useState<EWasteRequestDetails[]>([]);
  const [ucoRequestList, setUCORequestList] = useState<EWasteRequestDetails[]>([]);
  const [selectedServiceType, setSelectedServiceType] = useState<string>('');
  const [selectedRequestFrom, setSelectedRequestFrom] = useState<string>('');
  const [selectedSourceOfInfo, setSelectedSourceOfInfo] = useState<string>('');
  const [selectedSlot, setSelectedSlot] = useState<Slot>();
  const [modeOfPayment, setModeOfPayment] = useState<string>('');
  const [coupon, setCoupon] = useState<ICoupon | null>(null);
  const [tabValue, setTabValue] = useState('1');
  const { enableRaiseRequest } = props;

  const tableColumns = [
    {
      id: 'id',
      label: 'Request ID',
      sortDisable: false
    },
    {
      id: 'productName',
      label: 'Product Name',
      sortDisable: false
    },
    {
      id: 'cpName',
      label: 'Channel Partner Name',
      sortDisable: false
    },
    {
      id: 'tcName',
      label: tabValue === '2' ? 'Technician Name' : 'Collection Agent Name',
      sortDisable: false
    },
    {
      id: 'createdAt',
      label: 'Booking Date',
      sortDisable: false
    },
    {
      id: 'appointmentDate',
      label: 'Appointment Date',
      sortDisable: false
    },
    {
      id: 'status',
      label: 'Status',
      sortDisable: false
    }
  ];

  const setProduct = (details: GetUserProductResponse) => {
    setProductDetails(details);
    setIssues([]);
  };

  const setCpId = (data: string) => {
    setChannelPartnerId(data);
  };

  const setServiceType = (data: string) => {
    setSelectedServiceType(data);
  };
  const setRequestFrom = (data: string) => {
    setSelectedRequestFrom(data);
  };
  const setSourceOfInfo = (data: string) => {
    setSelectedSourceOfInfo(data);
  };

  const setIssuesList = (list: string[]) => {
    setIssues(list);
  };

  const getModOfPayment = (data: string) => {
    setModeOfPayment(data);
  };

  const setAddress = (address: CustomerAddress) => {
    setSelectedAddress(address);
  };

  const getAllUserProducts = async (userId) => {
    if (userId) {
      const userProductResponse = await userProductApi.getAllUserProducts(userId);
      if (userProductResponse?.statusCode === ResponseCodes.OK) {
        setAllUserProducts(userProductResponse?.responseData?.userProducts);
      }
    }
  };

  const noRequestMessage = () => (
    <Typography
      variant="h6"
      pl={1}
    >
      No Request Available
    </Typography>
  );

  const getUserDetails = async (mobileNumber) => {
    setLoading(true);
    setProductDetails({} as GetUserProductResponse);
    setSelectedAddress({} as CustomerAddress);
    setIssues([]);
    const result = await userApi.getUserByUserName(mobileNumber);
    if (result.statusCode === ResponseCodes.OK) {
      setUserDetails(result?.responseData);
      setUserFound(true);
      getAllUserProducts(result?.responseData?.username);
    } else if (result.statusCode === ResponseCodes.ERROR) {
      setMobile(mobileNumber);
      setUserFound(false);
      setUserDetails({} as CustomerGetResponse);
    } else {
      toast.error('Something Went Wrong');
      setUserDetails({} as CustomerGetResponse);
    }
    setLoading(false);
  };

  const updateProductState = () => {
    getAllUserProducts(userDetails?.username).catch(console.error);
  };

  const addEditCustomerProfile = async (
    profileDetails : CustomerUser, isAdd: boolean
  ): Promise<boolean> => {
    setLoading(true);
    let result;
    if (isAdd) {
      result = await userApi.createCustomerProfile(profileDetails);
    } else {
      result = await userApi.updateCustomerProfile(profileDetails);
    }
    if (result.statusCode === ResponseCodes.CREATED || result.statusCode === ResponseCodes.OK) {
      getUserDetails(profileDetails?.mobileNumber || profileDetails?.username);
      if (isAdd) {
        toast.success('Customer Profile Added');
      } else {
        toast.success('Customer Profile Updated');
      }
      return true;
    }
    toast.error('Something Went Wrong');
    setLoading(false);
    return false;
  };

  const addAddress = async (address: CustomerAddress): Promise<boolean> => {
    setLoading(true);
    if (userDetails?.username) {
      const result = await userApi.addCustomerAddress(userDetails?.username, address);
      if (result.statusCode === ResponseCodes.CREATED) {
        toast.success('Customer Address Added');
        getUserDetails(userDetails?.mobileNumber);
        return true;
      }
      toast.error('Something Went Wrong');
      setLoading(false);
      return false;
    }
    toast.error('Something Went Wrong');
    setLoading(false);
    return false;
  };

  const setSlotDetails = (data: Slot) => {
    setSelectedSlot(data);
  };

  const createRepairRequest = async () => {
    setLoading(true);
    const address : Address = {
      id: selectedAddress?.id,
      addressName: selectedAddress?.name,
      addressLine1: selectedAddress ? selectedAddress?.line1 : '',
      addressLine2: selectedAddress ? selectedAddress?.line2 : '',
      landmark: selectedAddress?.landmark || '',
      area: selectedAddress ? selectedAddress?.area : '',
      city: selectedAddress ? selectedAddress?.city : '',
      state: selectedAddress?.state,
      pincode: selectedAddress ? selectedAddress?.pincode : 0
    };
    const issuesList: SelectedIssue[] = [];
    issues?.map((item) => issuesList.push({ description: item }));
    const raiseRequestPayload = {
      id: '',
      userName: userDetails ? userDetails?.username : '',
      userProductId: userDetails ? productDetails?.id : '',
      issues: issuesList,
      paymentMethod: modeOfPayment,
      channelPartnerId,
      source: selectedSourceOfInfo,
      requestFrom: selectedRequestFrom,
      address,
      appointmentSlot: selectedSlot,
      serviceId: selectedServiceType,
      sparePartId: null,
      rewardPoints: 0,
      discount: coupon?.discount ? coupon.discount : 0
    };
    if (coupon?.code) {
      /* eslint-disable */
      raiseRequestPayload['couponCode'] = coupon?.code;
    }
    const result = await requestApi.raiseRepairRequest(raiseRequestPayload);
    if (result?.statusCode === ResponseCodes.CREATED) {
      setRequestDetails(result?.responseData);
      setOpenSuccessDialog(true);
    } else {
      toast.error(result?.responseData);
    }
    setLoading(false);
  };

  const handleCloseDialog = () => {
    setOpenSuccessDialog(false);
    navigate(`/dashboard/repair-request/view/${requestDetails?.id}`);
  };

  const renderStatus = (status) => {
    const color = tabValue === '2' ? getStatusColor(status) : getEWasteStatusColor(status);
    return (
      <Container
        disableGutters
        sx={{
          m: 0,
          px: 0,
          color: `${color}`,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            backgroundColor: `${color}`,
            borderRadius: '50%',
            height: 12,
            width: 12,
            ml: 0,
            my: 1,
            mr: 1
          }}
        />
        {status}
      </Container>
    );
  };

  const handleTabChange = (e, newValue) => {
    setTabValue(newValue);
  };

    // this method creates a list which show on tooltip
  const getReducedArray = (productArray: EwasteProduct[]) => {
    let i = 1;
    const modifiedStringArray: string[] = [];
    while (i < productArray.length) {
      modifiedStringArray.push(productArray[i++].name);
    }
    return modifiedStringArray;
  };

  const getRepairRequestDetails = async () => {
    const paginationObject: PaginationAndFilter = {
      filters: [{
        property: 'userName',
        operator: 'equal',
        value: userDetails?.username
      }],
      pageSize: 999,
      pageNumber: 1,
    };
    const result = await requestApi.getRequestsByPaginationAndFilters(paginationObject);
    if (result?.statusCode === ResponseCodes.OK) {
      setRepairRequestList(result?.responseData?.records);
    }
  };

  const getEwasteRequestDetails = async () => {
    const paginationObject: PaginationAndFilter = {
      filters: [{
        property: 'userName',
        operator: 'equal',
        value: userDetails?.username
      }],
      pageSize: 999,
      pageNumber: 1,
    };
    const result = await eWasteRequestApi.getEWasteRequestsByPaginationAndFilters(paginationObject);
     if (result?.statusCode === ResponseCodes.OK) {
    const records = result?.responseData?.records;
    const ucoRequests = records.filter((record: { serviceDetails: { id: string; }; }) => record.serviceDetails.id === UCO_WASTE_SERVICE_ID);
    setUCORequestList(ucoRequests);
    const plasticRequests = records.filter((record: { serviceDetails: { id: string; }; }) => record.serviceDetails.id === PLASTIC_WASTE_SERVICE_ID);
    setPlasticRequestList(plasticRequests)
    const ewasteRequests = records.filter((record: { serviceDetails: { id: string; }; }) => record.serviceDetails.id === EWASTE_SERVICE_ID);
    setEWasteRequestList(ewasteRequests);
  }
  };

  useEffect(() => {
    if (userDetails?.username) {
      getRepairRequestDetails().catch(console.error);
      getEwasteRequestDetails().catch(console.error);
    }
  }, [userDetails?.username]);

  useEffect(() => {
    if (customerId) {
      getUserDetails(customerId).catch(console.error);
    }
  }, [customerId]);

  const renderContent = () => (
    <>
      <Box
        sx={{
          flexGrow: 1,
          py: 3
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Box
            sx={{
              flexGrow: 1
            }}
          >
            {!customerId && (
            <MobileNumberCard
              getUserDetails={getUserDetails}
              userMobile={userDetails?.mobileNumber}
            />
            )}
            {userDetails?.username ? (
              <>
                <TabContext value={tabValue}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' , mt: 4}}>
                    <Grid
                      container
                    >
                      <Grid
                        item
                        md={12}
                        xs={12}
                      >
                        <TabList
                          onChange={handleTabChange}
                          aria-label="lab API tabs example"
                          sx={{
                            width: '100%',
                          }}
                        >
                          <Tab
                            label="Profile Details"
                            value="1"
                          />
                          <Tab
                            label="Repair Request"
                            value="2"
                          />
                          <Tab
                            label="E-Waste Request"
                            value="3"
                          />
                          <Tab
                            label="Plastic-Waste Request"
                            value="4"
                          />
                          <Tab
                            label="UCO Request"
                            value="5"
                          />
                        </TabList>
                      </Grid>
                    </Grid>
                  </Box>
                  <TabPanel
                    value="1"
                    sx={{ mt: 3, p: 0 }}
                  >
                    <ProfileDetailsCard
                      setProduct={setProduct}
                      setAddress={setAddress}
                      addAddress={addAddress}
                      productsList={allUserProducts}
                      userDetails={userDetails}
                      updateProductState={updateProductState}
                      addEditCustomerProfile={addEditCustomerProfile}
                      enableRaiseRequest={enableRaiseRequest}
                    />
                    { productDetails?.id && (
                    <Box
                      sx={{
                        my: 2,
                      }}
                    >
                      <Divider textAlign="center">
                        <Typography
                          sx={{
                            p: 1,
                            pl: 0,
                            my: 1
                          }}
                          variant="h5"
                        >
                          Book A Request
                        </Typography>
                      </Divider>
                      <RaiseRequestDetailsCard
                        selectedAddress={selectedAddress}
                        productDetails={productDetails}
                        setSlotDetails={setSlotDetails}
                        setServiceType={setServiceType}
                        setRequestFrom={setRequestFrom}
                        setSourceOfInfo={setSourceOfInfo}
                        setIssuesList={setIssuesList}
                        setCpId={setCpId}
                        setModeOfPayment={getModOfPayment}
                        setCoupon={setCoupon}
                      />
                      { selectedServiceType === REPAIR_SERVICE_ID && (
                      <>
                        <Box sx={{ py: 2 }}>
                          <Box
                            sx={{
                              alignItems: 'center',
                              display: 'flex',
                              pb: 3
                            }}
                          >
                            <Box sx={{ flexGrow: 1 }} />
                            <Button
                              variant="contained"
                              disabled={!(selectedAddress?.id && productDetails?.id
                            && selectedServiceType && selectedRequestFrom
                            && selectedSourceOfInfo && issues?.length
                          && selectedSlot?.date && selectedSlot?.slot !== '' && modeOfPayment
                          && channelPartnerId)}
                              onClick={() => { createRepairRequest(); }}
                            >
                              Raise Request
                            </Button>
                          </Box>
                        </Box>
                      </>
                      )}
                    </Box>
                    )}
                  </TabPanel>
                  <TabPanel
                    value="2"
                    sx={{ mt: 3, p: 0 }}
                  >
                    <Box
                      sx={{
                        backgroundColor: 'background.default',
                        flexGrow: 1,
                        m: 0,
                        pt: 1
                      }}
                    >
                        <Card
                          variant="outlined"
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flexGrow: 1
                          }}
                        >
                          <CardContent
                            sx={{
                              p: 0
                            }}
                          >
                            <Box>
                              {repairRequestList?.length > 0 ? (
                                <TableContainer
                                  sx={{
                                    maxHeight: '400px',
                                  }}
                                >
                                  <Table
                                    stickyHeader
                                    size="small"
                                    sx={{
                                      border: 1,
                                      borderColor: '#e1e3ea',
                                      borderRadius: '2px',
                                    }}
                                  >
                                    <TableHead>
                                      <TableRow>
                                        {tableColumns.map((column) => (
                                          <TableCell
                                            key={column.id}
                                            sx={{
                                              backgroundColor: 'neutral.100',
                                            }}
                                          >
                                            {column.label}
                                          </TableCell>
                                        ))}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {repairRequestList?.map((repairReq) => (
                                        <TableRow
                                          hover
                                          key={repairReq.id}
                                        >
                                          <TableCell
                                            align="left"
                                          >
                                            <Link
                                              color="primary"
                                              component={RouterLink}
                                              sx={{ display: 'block' }}
                                              to={`/dashboard/repair-request/view/${repairReq.id}`}
                                              underline="none"
                                              variant="subtitle2"
                                            >
                                              {repairReq.id}
                                            </Link>
                                          </TableCell>
                                          <TableCell
                                            align="justify"
                                          >
                                            {repairReq.productName}
                                          </TableCell>
                                          <TableCell align="justify">
                                            {repairReq?.assignee?.channelPartnerId ? repairReq.assignee.channelPartnerName : 'N/A'}
                                          </TableCell>
                                          <TableCell
                                            align="justify"
                                          >
                                            {repairReq?.assignee?.technicianId ? repairReq.assignee.technicianName : 'N/A'}
                                          </TableCell>
                                          <TableCell
                                            align="left"
                                          >
                                            {repairReq?.createdAt ? format(new Date(repairReq?.createdAt), 'MMM dd, yyyy') : 'N/A'}
                                          </TableCell>
                                          <TableCell
                                            align="left"
                                          >
                                            {repairReq?.appointmentSlot?.date ? format(new Date(repairReq.appointmentSlot.date), 'MMM dd, yyyy') : 'N/A'}
                                          </TableCell>
                                          <TableCell>
                                            {renderStatus(repairReq.status)}
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              ) : (
                                noRequestMessage()
                              )}
                            </Box>
                          </CardContent>
                          <CardActions
                            sx={{
                              p: 0
                            }}
                          />
                        </Card>
                    </Box>
                  </TabPanel>
                  <TabPanel
                    value="3"
                    sx={{ mt: 3, p: 0 }}
                  >
                    <RequestList requestLists={eWasteRequestList} tabValue={"3"}/>
                  </TabPanel>
                  <TabPanel
                    value="4"
                    sx={{ mt: 3, p: 0 }}
                  >
                   <RequestList requestLists={plasticRequestList} tabValue={'4'}/>
                  </TabPanel>
                  <TabPanel
                    value="5"
                    sx={{ mt: 3, p: 0 }}
                  >
                  <RequestList requestLists={ucoRequestList} tabValue={'5'}/>
                  </TabPanel>
                </TabContext>
              </>
            ) : (
              <Box
              >
                { !userFound && (
                  <CreateProfileCard
                    mobileNumber={mobile}
                    addEditCustomerProfile={addEditCustomerProfile}
                  />
                )}
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      { openSuccessDialog && requestDetails?.id && (
      <RequestSuccessDialog
        onClose={handleCloseDialog}
        requestId={requestDetails?.id}
        appointmentDate={new Date(requestDetails?.appointmentSlot?.date)}
        appointmentSlot={requestDetails?.appointmentSlot?.slot}
        customerName={`${userDetails?.firstName} ${userDetails?.lastName}`}
        open={openSuccessDialog}
      />
      )}
    </>
  );

  return (
    <>
      <Helmet>
        <title>Customer | ServCare</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          flexGrow: 1
        }}
      >
        {renderContent()}
      </Box>
    </>
  );
};

CustomerView.propTypes = {
  enableRaiseRequest: PropTypes.bool.isRequired
};
